var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

const $360 = {
    headerHeight: null,
    getHeaderHeight: function() {
        const header = document.getElementById('site-header');
        if(!header) return;
        this.headerHeight = header.offsetHeight;
    },
    // lazyLoadInstance: new LazyLoad({
    //     elements_selector: '.lazy',
    // }),
    setGlobalContentTopMargin: function() {
        if(!document.querySelector('body.sticky-header')) return;
        const el = document.querySelector('.global-content-top-margin');
        if(el) {
            el.style.marginTop = `${this.headerHeight - 1}px`;
        }
    },
    setStickyBelowHeaderPosition: function() {
        const el = document.querySelector('.sticky-below-header');
        if(el) {
            el.style.top = `${this.headerHeight - 1}px`;
        }
    },
    setMenuWrapperPosition: function() {
        let annBarHeight = 0;

        const elMobile = document.querySelector('.mobile-menu-wrapper');
        const elDesktop = document.querySelector('.menu-dropdown-wrapper');
        if(elMobile) {
            if(document.querySelector('.announcement-bar')) {
                annBarHeight = document.querySelector('.announcement-bar').offsetHeight;
            }

            const topAdditionalSpace = window.innerWidth < 1024 ? 58 : 61;
            let topMenuSpacing = annBarHeight + topAdditionalSpace;

            if(document.querySelector('body.hide-bar-on-scroll.scrolled')) {
                topMenuSpacing = topAdditionalSpace;
                if(window.innerWidth >= 1024) {
                    topMenuSpacing = topAdditionalSpace - 3;
                }
            }
            
            elMobile.style.top = `${topMenuSpacing}px`;
            elMobile.style.height = `calc(100% - ${topMenuSpacing}px)`;
        }
        if(elDesktop) {
            if(document.querySelector('body.hide-bar-on-scroll.scrolled')) {
                if(document.querySelector('.announcement-bar')) {
                    annBarHeight = document.querySelector('.announcement-bar').offsetHeight;
                }
                elDesktop.style.top = `${this.headerHeight - annBarHeight - 1}px`;
            } else {
                elDesktop.style.top = `${this.headerHeight - 1}px`;
            }
        }
    },
    setFullHeightPage: function() {
        const el = document.querySelector('.full-height-page');
        if(el) {
            el.style.height = `calc(100vh - ${this.headerHeight}px)`;
        }
    },
    btnLoading: function() {
        return `
            <span class="btn-loading">
                <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
            </span>
        `;
    },
    /**
     * args is an object of qty, variantId, properties, encodeProperties, button, showHeadercart
     * 
     * Add encodeProperties if there is properties need to be encode, 
     * example value is {properties_key: 'number'} 
     * the object value can be 'number' or 'text 
     * 
     * callback: function callback after success
     */
    addToCart: async function({qty, variantId, properties,  sellingPlanId, encodeProperties, button, showHeaderCart}, callback) {
        // const qty = args.qty;
        // const variantId = args.variantId;
        // let properties = args.properties;
        // const encodeProperties = args.encodeProperties;
        // const button = args.button;
        showHeaderCart = showHeaderCart ? showHeaderCart : true;

        let prevText;
        if(button) {
            prevText = button.innerHTML;
            button.style.height = `${button.offsetHeight}px`;
            button.style.width = `${button.offsetWidth}px`;
            button.innerHTML = this.btnLoading();
            button.setAttribute('disabled', true);
        }

        const data = {quantity: qty, id: variantId};
        if(sellingPlanId) {
            data.selling_plan = sellingPlanId;
        }

        if(properties) {
            data.properties = properties;

            if(encodeProperties) {
                Object.keys(encodeProperties).forEach(function(key) {
                    if(encodeProperties[key] == 'number') {
                        const numberCrypt = new NumberCrypt();
                        data.properties[key] = numberCrypt.encode(data.properties[key])
                    }
                })
            }
        }

        try {
            const fetchSettings = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            };
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', fetchSettings);
            const cart = await response.json();
            refreshCart(true);
          
            if(callback) {
                callback(cart);
            }
        } catch (error) {
            console.log(error);
        } finally {
            if(button) {
                button.innerHTML = prevText;
                button.removeAttribute('disabled');
                button.style.height = '';
                button.style.width = '';
            }
        }
    },
    addToCartQuick: function(button) {
        const qty = button.closest('.quick-action').querySelector('.quick-qty').value;
        const variantId = button.getAttribute('data-variant-id');
        const args = {qty, variantId, button};

        $360.addToCart(args);
    },
    crossSellAtc: function(button) {
        const qty = 1;
        const variantId = button.getAttribute('data-variant-id');
        const args = {qty, variantId, button};

        $360.addToCart(args);
    },
    addToCartMultiple: function(args, callback) {
        const products = args.products;
        /*
        products array is object that consist of these
        {
            varId: String. the variant id,
            qty: Numeric. Quantity to be added
            properties: Object. The line item properties Object
            See the details descriptions on addToCart function
        }
        */
        const button = args.button;
        const thisObj = this;

        let prevText;
        if(button) {
            prevText = button.innerHTML;
            button.style.height = `${button.offsetHeight}px`;
            button.style.width = `${button.offsetWidth}px`;
            button.innerHTML = this.btnLoading();
            button.setAttribute('disabled', true);
        }

        const addedItemKeys = [];
		Shopify.moveAlong = () => {
			if (products.length) {
				const product = products.shift();

                const productData = {
                    id: product.varId,
                    quantity: product.qty 
                };

                if(product.hasOwnProperty('properties')) {
                    productData.properties = product.properties;

                    if(productData.properties.hasOwnProperty('encodeProperties')) {
                        const encodeProperties = productData.properties.encodeProperties
                        Object.keys(encodeProperties).forEach(function(key) {
                            if(encodeProperties[key] == 'number') {
                                const numberCrypt = new NumberCrypt();
                                productData.properties[key] = numberCrypt.encode(productData.properties[key])
                            }
                        })
                    }
                };

                const fetchSettings = {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(productData)
                };
                fetch(window.Shopify.routes.root + 'cart/add.js', fetchSettings)
                    .then((response) => {
						Shopify.moveAlong();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
			} else {
                if(button) {
                    button.innerHTML = prevText;
                    button.removeAttribute('disabled');
                    button.style.height = '';
                    button.style.width = '';
                }

                if(callback) {
                    callback();
                }

                refreshCart(true);
			}
		};
		Shopify.moveAlong();
    },
    updateItemQty: async function({index, qty, groupId, removeSameGroup}, callback) {
        const thisObj = this;
        if(removeSameGroup) {
            // if(removeSameGroup && document.querySelector('.header-cart-loading') && !document.getElementById('cart-content')) {
            //     document.querySelector('.header-cart-loading').classList.add('active');
            // }
            document.querySelector('.page-loading').classList.add('active');
        }

        const doneUpdate = function(callback, cart) {
            if(callback) {
                callback(cart);
            }
            if(document.getElementById('cart-content')) {
                location.reload();
            }
        }

        try {
            const fetchSettings = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({line: index, quantity: qty})
            };
            const response = await fetch(window.Shopify.routes.root + 'cart/change.js', fetchSettings);
            const cart = await response.json();

            if(cart.item_count == 0 && document.getElementById('cart-page-cross-sell')) {
                document.getElementById('cart-page-cross-sell').classList.add('hide-m');
            }

            if(groupId && removeSameGroup) {
                const anotherIndex = cart.items.findIndex(item => {
                    if(item.properties.hasOwnProperty('_group_id')) {
                        return item.properties._group_id == groupId && item.quantity != qty;
                    } else {
                        return false;
                    }
                });

                if(anotherIndex > -1) {
                    thisObj.updateItemQty({
                        index: anotherIndex + 1,
                        qty: qty,
                        groupId: groupId,
                        removeSameGroup: true
                    }, callback)
                } else {
                    setTimeout(() => {
                        document.querySelector('.page-loading').classList.remove('active');
                    }, 700);
                    doneUpdate(callback, cart);
                }
            } else {
                doneUpdate(callback, cart);
            }
        } catch (error) {
            console.log(error);
        }
    },
    showHeaderCart: function(args = {}, callback) {
        // callback has cart data object
        const from_cart = args.hasOwnProperty('from_cart') ? args.from_cart : false;
        const update = args.hasOwnProperty('update') ? args.update : false;
        const thisObj = this;
        let cart_url = window.Shopify.routes.root + 'cart';
        var crossSellSwiper = null;

		const initCrossSellingSection = () => {
            if(crossSellSwiper == null) {
                crossSellSwiper = new Swiper('.header-cart .cross-sell .swiper', {
                    slidesPerView: 1.37,
                    slidesOffsetBefore: 25,
                    slidesOffsetAfter: 25,
                    spaceBetween: 15,
                    pagination: {
                        el: ".header-cart .cross-sell .swiper-pagination",
                        clickable: true
                    },
                    navigation: {
                        nextEl: ".header-cart .cross-sell .swiper-btn-next",
                        prevEl: ".header-cart .cross-sell .swiper-btn-prev",
                    },
                    breakpoints: {
                        1024:{
                            slidesPerView: 1.7,
                            slidesOffsetBefore: 25,
                            slidesOffsetAfter: 25,
                            spaceBetween: 20,
                        }
                    },
                    on: {
                        init: (swiper) => {
                            // $360.lazyLoadInstance.update();
                        }
                    }
                });
            }
        }
        
        const showIt = () => {
            document.getElementById('header-cart').action = cart_url;
            document.getElementById('header-cart').classList.add('active');
            document.querySelector('.header-cart-overlay').classList.add('active');

			initCrossSellingSection();

            // if(document.querySelector('.header-cart-loading')) {
            //     document.querySelector('.header-cart-loading').classList.remove('active');
            // }

            this.hideFloatingApp();
            this.disableScroll();
            // thisObj.lazyLoadInstance.update();
        };

        if(!update && document.getElementById('header-cart').childNodes.length) {
            showIt();
            return;
        }

        const initCartNoteForm = () => {
            const {slideDown, slideUp, slideToggle} = window.domSlider

            const note_cb = document.querySelector('#hc-note-cb');
			if (!note_cb) return;

			note_cb.addEventListener('change', function(cEv){
				const value = cEv.target.checked;
				const inputNote = document.querySelector('#hc-note-input');
				const cbContainer = note_cb.closest('.note-cb-container')
				const cbLabel = cbContainer.querySelector('.cb-note-label');
				if (!inputNote) return;
				slideToggle({element: inputNote})
				if (!value) {
					// cbLabel.innerHTML = cbContainer.querySelector('input[name="cb_label"]').value;
					inputNote.value = '';
				} else {
					// cbLabel.innerHTML = cbContainer.querySelector('input[name="cb_label_added"]').value;
				}
			})
        }
        
        axios.get(window.Shopify.routes.root + 'cart.js')
            .then((response) => {
                const cart = response.data;
                thisObj.updateHeaderCartCount(cart);

                if(document.getElementById('cart-content')) {
                    thisObj.updateCartPage(cart.item_count);
                }
                
                axios.get(window.Shopify.routes.root + 'cart?view=json')
                    .then((response) => {
                        const html = response.data;
                        document.getElementById('header-cart').innerHTML = html;
                        thisObj.adjustCartHeight();
                        if(!from_cart) {
                            showIt();
                        }
                        this.hideFloatingApp();
                        if(!from_cart) {
                            this.disableScroll();
                        }
                        // initCartNoteForm();
                        initCrossSellingSection();
                        if(cart.item_count > 0 && document.querySelector('#header-cart .cross-sell')) {
                            document.getElementById('header-cart').classList.remove('no-cross-sell');
                            document.getElementById('header-cart').classList.add('flex', 'column-reverse', 'jc-between', 't-flex-row', 't-jc-start');
                        } else {
                            document.getElementById('header-cart').classList.add('no-cross-sell');
                            document.getElementById('header-cart').classList.remove('flex', 'column-reverse', 'jc-between', 't-flex-row', 't-jc-start');
                        }
                        if(callback) {
                            callback(cart)
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            })
            .catch((error) => {
                console.log(error);
            });
        window.addEventListener("resize", function (resizeEv){
            thisObj.adjustCartHeight();
        });
    },
    hideHeaderCart: function() {
        document.getElementById('header-cart').classList.remove('active');
        document.querySelector('.header-cart-overlay').classList.remove('active');
        document.querySelector('.header-cart-overlay').classList.add('fade-out');
        setTimeout(function() {
            document.querySelector('.header-cart-overlay').classList.remove('fade-out');
        }, 150);
        this.enableScroll();
        this.showFloatingApp();
    },
    updateHeaderCartCount(cart) {
        let count = 0;
        cart.items.forEach(item => {
            // if(item.properties) {
            //     if(!item.properties.hasOwnProperty('_group_id')) {
            //         count = count + item.quantity;
            //     } else {
            //         if(item.properties.hasOwnProperty('_group_parent')) {
            //             count = count + item.quantity;
            //         }
            //     }
            // } else {
            //     count = count + item.quantity;
            // }
            count = count + item.quantity;
        });

        document.querySelector('.header-cart-number .cart-count').textContent = count;
        if(count > 0) {
            document.querySelector('.header-cart-number').classList.add('has-item');
            // document.querySelector('.header-right').classList.add('has-cart-item');
        } else {
            document.querySelector('.header-cart-number').classList.remove('has-item');
            // document.querySelector('.header-right').classList.remove('has-cart-item');
        }
    },
    adjustCartHeight: function() {
        if(document.querySelector('.header-cart-bottom')) {
            let topHeight = document.querySelector('.header-cart-title').offsetHeight;
            if(document.querySelector('.header-cart-middle .free-shipping-info')) {
                topHeight = topHeight + document.querySelector('.header-cart-middle .free-shipping-info').offsetHeight;
            }
            const bottomHeight = document.querySelector('.header-cart-bottom').offsetHeight;
            const height = `calc(100vh - ${topHeight + bottomHeight}px)`;
            // document.querySelector('.cart-items-wrapper').style.height = height;
        }
    },
    refreshCartPage: function() {
        const obj360 = this;
        if(document.getElementById('cart-content')) {
            axios.get(window.Shopify.routes.root + 'cart?view=jsonpage')
                .then(function(response) {
                    const cartRight = document.querySelector(".cart-right");
                    document.getElementById('cart-content').innerHTML = response.data;
                    document.querySelector('.page-loading').classList.remove('active');

					// show/hide note mech
					const {slideDown, slideUp, slideToggle} = window.domSlider
				
					const note_cb = document.querySelector('#pc-note-cb');
					if (!note_cb) return;
			
					note_cb.addEventListener('change', function(cEv){
						const value = cEv.target.checked;
						const inputNote = document.querySelector('#pc-note-input');
						const cbContainer = note_cb.closest('.note-cb-container')
						const cbLabel = cbContainer.querySelector('.cb-note-label');
						if (!inputNote) return;
						slideToggle({element: inputNote})
						if (!value) {
							// cbLabel.innerHTML = cbContainer.querySelector('input[name="cb_label"]').value;
							inputNote.value = '';
						} else {
							// cbLabel.innerHTML = cbContainer.querySelector('input[name="cb_label_added"]').value;
						}
					})
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    },
    handleCartNote: function(e) {

        const noteForm = document.querySelector('.add-cart-note-form');
        const noteFormInline = document.querySelector('.add-cart-note-form-inline');
        //const noteCheckbox = document.querySelector('.add-cart-note-checkbox');
        const noteInput = document.querySelector('.add-cart-note-input');

        /*-- character counter */
        const maxChars = noteInput.maxLength;
        noteInput.addEventListener('input', function() {
            let counter = maxChars - noteInput.value.length;
            noteInput.nextElementSibling.querySelector('.counter').textContent = counter;
        });

        if( e.target.classList.contains('add-cart-note-trigger') ) {
            noteForm.classList.add('active');
        }

        if( e.target.classList.contains('add-cart-note-trigger-inline') ) {
            noteFormInline.classList.add('active');
        }

        if( noteForm.classList.contains('active') || noteFormInline.classList.contains('active') ){
            noteInput.focus();
        }
        if( e.target.classList.contains('overlay') ) {
            noteForm.classList.remove('active');
            noteFormInline.classList.remove('active');
            //noteCheckbox.checked = false;
        }
        if( e.target.classList.contains('btn-cancel-note') ) {
            noteInput.value = '';
            noteForm.classList.remove('active');
            noteFormInline.classList.remove('active');
            //noteCheckbox.checked = false;
        }
        if( e.target.classList.contains('btn-save-note') ) {
            const noteContent = document.querySelector('.add-cart-note-input').value;
        }
    },
    updateCartNote: async function(e, callback) {

        // document.querySelector('.header-cart-loading').classList.add('active');

        let newNoteContent;
        if( e.target.classList.contains('btn-save-note') ) {
            newNoteContent = document.querySelector('.add-cart-note-input').value;
        } else if ( e.target.classList.contains('btn-remove-note') ) {
            newNoteContent = '';
        }
        const doneUpdate = function(callback, cart) {
            if(callback) {
                callback(cart);
            }
        }
        try {
            const updateCartNote = await axios.post(window.Shopify.routes.root + 'cart/update.js', {note: newNoteContent});
            const cart = updateCartNote.data;
            doneUpdate(callback, cart);
        } catch (error) {
            alert(error.response.data.message);
        }
    },
    productEachColorPicker: function(e, img_url) {
        const swatch_wrapper = e.target.closest('.swatch-wrapper');
        swatch_wrapper.querySelector('.swatch.active').classList.remove('active');

        const this_elem = e.target.closest('.swatch');
        this_elem.classList.add('active');

        const color = this_elem.getAttribute('data-value');
        const swatch_label = e.target.closest('.color-variant-picker').querySelectorAll('.swatch-label');

        swatch_label.forEach(elem => {
            elem.innerHTML = color;
        });

        const image_primary = e.target.closest('.product-each').querySelector('.primary img');
        const image_secondary = e.target.closest('.product-each').querySelector('.secondary img');

        if(img_url){

            image_primary.setAttribute('data-src','');
            image_primary.setAttribute('data-srcset','');
            image_primary.setAttribute('srcset','');
            image_primary.setAttribute('src',img_url);

            if( image_secondary ) {
                image_secondary.setAttribute('data-src','');
                image_secondary.setAttribute('data-srcset','');
                image_secondary.setAttribute('srcset','');
                image_secondary.setAttribute('src',img_url);
            }
        }
    },
    accordionToggle: function(e, className = null) {
        // if className is provided, only 1 accordion would be open
        const {slideUp, slideToggle} = window.domSlider
        
        let el = e.target;
        if(!el.classList.contains('accordion-title')) {
            el = el.closest('.accordion-title');
        }

        if(el.classList.contains('active')) {
            el.classList.remove('active');
            if(el.closest('.accordion')) {
                // el.closest('.accordion').classList.remove('b-black');
                // el.closest('.accordion').classList.add('b-border');
            }
        } else {
            el.classList.add('active');
            if(el.closest('.accordion')) {
                // el.closest('.accordion').classList.add('b-black');
                // el.closest('.accordion').classList.remove('b-border');
            }
        }

        if(className) {
            const parentEl = el.closest('.accordion').parentNode;
            parentEl.querySelectorAll(`.accordion ${className}`).forEach(element => {
                if(element != el.nextElementSibling) {
                    element.previousElementSibling.classList.remove('active');
                    slideUp({element});
                }
            });
        }

        slideToggle({element: el.nextElementSibling});
    },
    getSearchContent: async function(tpl, q) {
        let surl = `/search?type=product&view=${tpl}&q=${q}`;
        try {
            const goFind = await axios.get(surl);
            return goFind;
        } catch (error) {
            alert(error.response.data.message);
        }
    },
    youtubeVideoId(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    },
    setCookie: function(name, value, expires, expiresUnit) {
        const now = new Date();
        if(expiresUnit == 'minute') {
            now.setTime(now.getTime() + (expires * 60 * 1000));
        }
        if(expiresUnit == 'hour') {
            now.setTime(now.getTime() + (expires * 3600 * 1000));
        }
        if(expiresUnit == 'day') {
            now.setTime(now.getTime() + (expires * 86400000));
        }
        document.cookie = `${name}=${value}; expires=${now.toUTCString()}; path=/`;
    },
    getCookie: function(name) {
        // const re = new RegExp(`(?<=${name}=)[^;]*`); Old regex does not support on safari
        const re = new RegExp(`(?:${name}=)[^;]*`);

        try {
            return document.cookie.match(re)[0];
        } catch {
            return null;
        }
    },
    formatDate(dateIsoString) {
        const date = new Date(dateIsoString);
        const year = date.getFullYear();
        let  month = date.getMonth() + 1;
        let day = date.getDate();

        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }

        return `${day}/${month}/${year}`;
    },
    formatMoney(num, with_currency_code = false) {
        if(with_currency_code) {
            return Shopify.formatMoney(num, $360Shop.money_with_currency_format);
        }

        let format = Shopify.formatMoney(num, $360Shop.money_format);
        format = format.replace('class=money', 'class="money"');
        return format
    },
    scrollTo(elString, additionalSpacing = null) {
        const c = document.querySelector(''+elString+'');
        if (typeof(c) != 'undefined' && c != null) {
            const achr_target = document.querySelector(''+elString+'');
            const elPos = achr_target.getBoundingClientRect().top;
            const bodyPos = document.body.getBoundingClientRect().top;
            const tPos = elPos - bodyPos - $360.headerHeight - additionalSpacing;
            window.scrollTo({
                top: tPos,
                behavior: 'smooth'
            });
        }
    },
    setGlobalSelectDivValue: function(fieldId, selectValue) {
        const selectEl = document.getElementById(fieldId);
      
        selectEl.value = selectValue;
        const wrapperEl = selectEl.closest('.global-select-div');
        if(!wrapperEl.classList.contains('selected-inline')) {
            wrapperEl.querySelector('.label').innerHTML = '';
        }
        wrapperEl.querySelectorAll('.option').forEach(optionEl => {
            if(optionEl.getAttribute('data-value') == selectValue) {
                wrapperEl.querySelector('.text').innerHTML = optionEl.textContent;
            }
        });
    },
    updateQueryString: function(key, value, url) {
        if (!url) url = window.location.href;

        let updated = ''
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
            hash;
    
        if (re.test(url)) {
            if (typeof value !== 'undefined' && value !== null) {
                updated = url.replace(re, '$1' + key + "=" + value + '$2$3');
            } else {
                hash = url.split('#');
                url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                    url += '#' + hash[1];
                }
                updated = url;
            }
        } else {
            if (typeof value !== 'undefined' && value !== null) {
                var separator = url.indexOf('?') !== -1 ? '&' : '?';
                hash = url.split('#');
                url = hash[0] + separator + key + '=' + value;
                if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                    url += '#' + hash[1];
                }
                updated = url;
            } else {
                updated = url;
            }
        }
    
        window.history.replaceState({ path: updated }, '', updated);
    },
    productCard2VariantChange: function(el) {
        const productCard = el.closest('.product-card-2');
        const variants = JSON.parse(decodeURIComponent(productCard.getAttribute('data-variants')));

        let option1 = null;
        let option2 = null;
        let option3 = null;
        if(productCard.querySelector('select.option1')) {
            option1 = productCard.querySelector('select.option1').value;
        }
        if(productCard.querySelector('select.option2')) {
            option2 = productCard.querySelector('select.option2').value;
        }
        if(productCard.querySelector('select.option3')) {
            option3 = productCard.querySelector('select.option3').value;
        }

        const filteredVariants = variants.filter(v => v.option1 == option1 && v.option2 == option2 && v.option3 == option3);
        if(filteredVariants.length) {
            const variantId = filteredVariants[0].id;
            productCard.querySelector('.add-to-cart').setAttribute('data-variant-id', variantId);
        }
    },
    getScrollbarWidth: function() {
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll';
        outer.style.msOverflowStyle = 'scrollbar'; // Needed for WinJS apps
        document.body.appendChild(outer);
    
        const inner = document.createElement('div');
        outer.appendChild(inner);
    
        const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    
        // Clean up temporary elements
        outer.parentNode.removeChild(outer);
    
        return scrollbarWidth;
    },
    disableScroll: function() {
        const gap = this.getScrollbarWidth();
        document.querySelector('body').classList.add('disable-scroll');
        document.body.style.paddingRight = `${gap}px`;
        if(document.querySelector('.header-bar')) {
            document.querySelector('.header-bar').style.paddingRight = `${gap}px`;
        }
        if(window.innerWidth >= 1024) {
            document.querySelector('.header-con').style.paddingRight = `${gap}px`;
        }
    },
    enableScroll: function() {
        document.querySelector('body').classList.remove('disable-scroll');
        document.body.style.paddingRight = null;
        if(document.querySelector('.header-bar')) {
            document.querySelector('.header-bar').style.paddingRight = null;
        }
        if(window.innerWidth >= 1024) {
            document.querySelector('.header-con').style.paddingRight = null;
        }
    },
    hideFloatingApp: function() {
        // Add code here if needed
    },
    showFloatingApp: function() {
        // Add code here if needed
    },
    updateCartPage(cart) {
        const mainCon = document.querySelector('.global-content-top-margin');
        const allSection = mainCon.querySelectorAll('.shopify-section');
        let target = null;
        allSection.forEach(sec => {
            target = sec.querySelector('#cart-content');
            if(!target) {
                if(cart > 0) {
                    sec.classList.remove('hide-m');
                } else {
                    sec.classList.add('hide-m');
                }
                
            }
        });
    }
}

// const refresh360_functions = [];

// refresh360_functions.push('getHeaderHeight');
// refresh360_functions.push('setGlobalContentTopMargin');
// refresh360_functions.push('setStickyBelowHeaderPosition');
// refresh360_functions.push('setMenuWrapperPosition');
// refresh360_functions.push('setFullHeightPage');
